import { parseArrowInBatches } from "./parse-arrow-in-batches.js";
export function parseGeoArrowInBatches(asyncIterator) {
  return parseArrowInBatches(asyncIterator);
}
//# sourceMappingURL=parse-geoarrow-in-batches.js.map